import { __decorate } from 'tslib';
import { EventEmitter, ChangeDetectorRef, ElementRef, NgZone, Component, ChangeDetectionStrategy, Renderer2, HostListener, Directive, forwardRef, NgModule } from '@angular/core';
import { applyPolyfills, defineCustomElements } from '@one/web-components/loader';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/* eslint-disable */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
const proxyInputs = (Cmp, inputs) => {
    const Prototype = Cmp.prototype;
    inputs.forEach(item => {
        Object.defineProperty(Prototype, item, {
            get() {
                return this.el[item];
            },
            set(val) {
                this.z.runOutsideAngular(() => (this.el[item] = val));
            }
        });
    });
};
const proxyMethods = (Cmp, methods) => {
    const Prototype = Cmp.prototype;
    methods.forEach(methodName => {
        Prototype[methodName] = function () {
            const args = arguments;
            return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
        };
    });
};
const proxyOutputs = (instance, el, events) => {
    events.forEach(eventName => (instance[eventName] = new EventEmitter()));
};
function ProxyCmp(opts) {
    const decorator = function (cls) {
        if (opts.inputs) {
            proxyInputs(cls, opts.inputs);
        }
        if (opts.methods) {
            proxyMethods(cls, opts.methods);
        }
        return cls;
    };
    return decorator;
}

let InternalLifecycleActivator = class InternalLifecycleActivator {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
InternalLifecycleActivator.ɵfac = function InternalLifecycleActivator_Factory(t) { return new (t || InternalLifecycleActivator)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
InternalLifecycleActivator.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InternalLifecycleActivator, selectors: [["internal-lifecycle-activator"]], inputs: { loaded: "loaded" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function InternalLifecycleActivator_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
InternalLifecycleActivator.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
InternalLifecycleActivator = __decorate([
    ProxyCmp({
        inputs: ['loaded']
    }),
], InternalLifecycleActivator);
let OwcAvatar = class OwcAvatar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcAvatar.ɵfac = function OwcAvatar_Factory(t) { return new (t || OwcAvatar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcAvatar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcAvatar, selectors: [["owc-avatar"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcAvatar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcAvatar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
let OwcBackdrop = class OwcBackdrop {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['backdropClick']);
    }
};
OwcBackdrop.ɵfac = function OwcBackdrop_Factory(t) { return new (t || OwcBackdrop)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBackdrop.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBackdrop, selectors: [["owc-backdrop"]], inputs: { disableScrollLock: "disableScrollLock", elevation: "elevation", height: "height", minWidth: "minWidth", opacity: "opacity", width: "width" }, outputs: { backdropClick: "backdropClick" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBackdrop_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBackdrop.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBackdrop = __decorate([
    ProxyCmp({
        inputs: ['disableScrollLock', 'elevation', 'height', 'minWidth', 'opacity', 'width']
    }),
], OwcBackdrop);
let OwcBadge = class OwcBadge {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcBadge.ɵfac = function OwcBadge_Factory(t) { return new (t || OwcBadge)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBadge.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBadge, selectors: [["owc-badge"]], inputs: { size: "size", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBadge_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBadge.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBadge = __decorate([
    ProxyCmp({
        inputs: ['size', 'type']
    }),
], OwcBadge);
let OwcBanner = class OwcBanner {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['dismiss']);
    }
};
OwcBanner.ɵfac = function OwcBanner_Factory(t) { return new (t || OwcBanner)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBanner.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBanner, selectors: [["owc-banner"]], inputs: { dismissible: "dismissible", type: "type" }, outputs: { dismiss: "dismiss" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBanner_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBanner.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBanner = __decorate([
    ProxyCmp({
        inputs: ['dismissible', 'type']
    }),
], OwcBanner);
let OwcBottomNav = class OwcBottomNav {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bottomNavChange']);
    }
};
OwcBottomNav.ɵfac = function OwcBottomNav_Factory(t) { return new (t || OwcBottomNav)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBottomNav.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBottomNav, selectors: [["owc-bottom-nav"]], inputs: { disableRipple: "disableRipple", value: "value", variant: "variant" }, outputs: { bottomNavChange: "bottomNavChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBottomNav_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBottomNav.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBottomNav = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'value', 'variant']
    }),
], OwcBottomNav);
let OwcBottomNavItem = class OwcBottomNavItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcBottomNavItem.ɵfac = function OwcBottomNavItem_Factory(t) { return new (t || OwcBottomNavItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBottomNavItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBottomNavItem, selectors: [["owc-bottom-nav-item"]], inputs: { caption: "caption", disableRipple: "disableRipple", icon: "icon", iconType: "iconType", selected: "selected", value: "value", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBottomNavItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBottomNavItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBottomNavItem = __decorate([
    ProxyCmp({
        inputs: ['caption', 'disableRipple', 'icon', 'iconType', 'selected', 'value', 'variant']
    }),
], OwcBottomNavItem);
let OwcBreadcrumb = class OwcBreadcrumb {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcBreadcrumb.ɵfac = function OwcBreadcrumb_Factory(t) { return new (t || OwcBreadcrumb)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBreadcrumb.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBreadcrumb, selectors: [["owc-breadcrumb"]], inputs: { icon: "icon" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBreadcrumb_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBreadcrumb.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBreadcrumb = __decorate([
    ProxyCmp({
        inputs: ['icon']
    }),
], OwcBreadcrumb);
let OwcBreadcrumbItem = class OwcBreadcrumbItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['handleUrl']);
    }
};
OwcBreadcrumbItem.ɵfac = function OwcBreadcrumbItem_Factory(t) { return new (t || OwcBreadcrumbItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcBreadcrumbItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcBreadcrumbItem, selectors: [["owc-breadcrumb-item"]], inputs: { icon: "icon", iconType: "iconType", url: "url" }, outputs: { handleUrl: "handleUrl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcBreadcrumbItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcBreadcrumbItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcBreadcrumbItem = __decorate([
    ProxyCmp({
        inputs: ['icon', 'iconType', 'url']
    }),
], OwcBreadcrumbItem);
let OwcButton = class OwcButton {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcButton.ɵfac = function OwcButton_Factory(t) { return new (t || OwcButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcButton, selectors: [["owc-button"]], inputs: { disableRipple: "disableRipple", disabled: "disabled", flat: "flat", round: "round", type: "type", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcButton.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcButton = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'disabled', 'flat', 'round', 'type', 'variant']
    }),
], OwcButton);
let OwcCalendar = class OwcCalendar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['dateSelect', 'visibleDateChange']);
    }
};
OwcCalendar.ɵfac = function OwcCalendar_Factory(t) { return new (t || OwcCalendar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcCalendar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcCalendar, selectors: [["owc-calendar"]], inputs: { date: "date", disabledDates: "disabledDates", from: "from", hideCurrent: "hideCurrent", hideHeader: "hideHeader", locale: "locale", max: "max", min: "min", to: "to", viewMode: "viewMode", weekStartsOn: "weekStartsOn" }, outputs: { dateSelect: "dateSelect", visibleDateChange: "visibleDateChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcCalendar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcCalendar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcCalendar = __decorate([
    ProxyCmp({
        inputs: ['date', 'disabledDates', 'from', 'hideCurrent', 'hideHeader', 'locale', 'max', 'min', 'to', 'viewMode', 'weekStartsOn']
    }),
], OwcCalendar);
let OwcCard = class OwcCard {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcCard.ɵfac = function OwcCard_Factory(t) { return new (t || OwcCard)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcCard.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcCard, selectors: [["owc-card"]], inputs: { disabled: "disabled", flat: "flat", round: "round", scrollShadow: "scrollShadow" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcCard_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcCard.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcCard = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'flat', 'round', 'scrollShadow']
    }),
], OwcCard);
let OwcCheckbox = class OwcCheckbox {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputChange']);
    }
};
OwcCheckbox.ɵfac = function OwcCheckbox_Factory(t) { return new (t || OwcCheckbox)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcCheckbox.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcCheckbox, selectors: [["owc-checkbox"]], inputs: { checked: "checked", disableRipple: "disableRipple", disabled: "disabled", indeterminate: "indeterminate", labelPlacement: "labelPlacement", name: "name" }, outputs: { inputChange: "inputChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcCheckbox_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcCheckbox.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcCheckbox = __decorate([
    ProxyCmp({
        inputs: ['checked', 'disableRipple', 'disabled', 'indeterminate', 'labelPlacement', 'name']
    }),
], OwcCheckbox);
let OwcChip = class OwcChip {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['remove']);
    }
};
OwcChip.ɵfac = function OwcChip_Factory(t) { return new (t || OwcChip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcChip.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcChip, selectors: [["owc-chip"]], inputs: { disableRipple: "disableRipple", disabled: "disabled", icon: "icon", outlined: "outlined", removable: "removable", round: "round", selected: "selected" }, outputs: { remove: "remove" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcChip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcChip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcChip = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'disabled', 'icon', 'outlined', 'removable', 'round', 'selected']
    }),
], OwcChip);
let OwcCookieAcceptance = class OwcCookieAcceptance {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['acceptSelect']);
    }
};
OwcCookieAcceptance.ɵfac = function OwcCookieAcceptance_Factory(t) { return new (t || OwcCookieAcceptance)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcCookieAcceptance.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcCookieAcceptance, selectors: [["owc-cookie-acceptance"]], inputs: { acceptAllText: "acceptAllText", acceptSelectionText: "acceptSelectionText", barVisibility: "barVisibility", cancel: "cancel", preferences: "preferences", settingsTitle: "settingsTitle" }, outputs: { acceptSelect: "acceptSelect" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcCookieAcceptance_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcCookieAcceptance.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcCookieAcceptance = __decorate([
    ProxyCmp({
        inputs: ['acceptAllText', 'acceptSelectionText', 'barVisibility', 'cancel', 'preferences', 'settingsTitle']
    }),
], OwcCookieAcceptance);
let OwcCookieAcceptanceOption = class OwcCookieAcceptanceOption {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcCookieAcceptanceOption.ɵfac = function OwcCookieAcceptanceOption_Factory(t) { return new (t || OwcCookieAcceptanceOption)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcCookieAcceptanceOption.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcCookieAcceptanceOption, selectors: [["owc-cookie-acceptance-option"]], inputs: { accepted: "accepted", disabled: "disabled", name: "name" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcCookieAcceptanceOption_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcCookieAcceptanceOption.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcCookieAcceptanceOption = __decorate([
    ProxyCmp({
        inputs: ['accepted', 'disabled', 'name']
    }),
], OwcCookieAcceptanceOption);
let OwcDatepicker = class OwcDatepicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['valueChange', 'panelOpen', 'panelClose']);
    }
};
OwcDatepicker.ɵfac = function OwcDatepicker_Factory(t) { return new (t || OwcDatepicker)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcDatepicker.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcDatepicker, selectors: [["owc-datepicker"]], inputs: { autoClose: "autoClose", compact: "compact", disabled: "disabled", disabledDates: "disabledDates", format: "format", hasClearIcon: "hasClearIcon", invalidDateMessage: "invalidDateMessage", label: "label", locale: "locale", maxDate: "maxDate", maxDateMessage: "maxDateMessage", minDate: "minDate", minDateMessage: "minDateMessage", name: "name", placeholder: "placeholder", quick: "quick", required: "required", requiredDateMessage: "requiredDateMessage", type: "type", value: "value", variant: "variant", weekStartsOn: "weekStartsOn" }, outputs: { valueChange: "valueChange", panelOpen: "panelOpen", panelClose: "panelClose" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcDatepicker_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcDatepicker.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcDatepicker = __decorate([
    ProxyCmp({
        inputs: ['autoClose', 'compact', 'disabled', 'disabledDates', 'format', 'hasClearIcon', 'invalidDateMessage', 'label', 'locale', 'maxDate', 'maxDateMessage', 'minDate', 'minDateMessage', 'name', 'placeholder', 'quick', 'required', 'requiredDateMessage', 'type', 'value', 'variant', 'weekStartsOn']
    }),
], OwcDatepicker);
let OwcDatepickerYearItem = class OwcDatepickerYearItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcDatepickerYearItem.ɵfac = function OwcDatepickerYearItem_Factory(t) { return new (t || OwcDatepickerYearItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcDatepickerYearItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcDatepickerYearItem, selectors: [["owc-datepicker-year-item"]], inputs: { current: "current", disabled: "disabled", selected: "selected" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcDatepickerYearItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcDatepickerYearItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcDatepickerYearItem = __decorate([
    ProxyCmp({
        inputs: ['current', 'disabled', 'selected']
    }),
], OwcDatepickerYearItem);
let OwcDivider = class OwcDivider {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcDivider.ɵfac = function OwcDivider_Factory(t) { return new (t || OwcDivider)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcDivider.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcDivider, selectors: [["owc-divider"]], inputs: { vertical: "vertical" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcDivider_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcDivider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcDivider = __decorate([
    ProxyCmp({
        inputs: ['vertical']
    }),
], OwcDivider);
let OwcDoubleGlobalArea = class OwcDoubleGlobalArea {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcDoubleGlobalArea.ɵfac = function OwcDoubleGlobalArea_Factory(t) { return new (t || OwcDoubleGlobalArea)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcDoubleGlobalArea.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcDoubleGlobalArea, selectors: [["owc-double-global-area"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcDoubleGlobalArea_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcDoubleGlobalArea.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
let OwcDrawer = class OwcDrawer {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['visibleChange', 'minify']);
    }
};
OwcDrawer.ɵfac = function OwcDrawer_Factory(t) { return new (t || OwcDrawer)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcDrawer.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcDrawer, selectors: [["owc-drawer"]], inputs: { hideBackdrop: "hideBackdrop", mini: "mini", mode: "mode", placement: "placement", visible: "visible" }, outputs: { visibleChange: "visibleChange", minify: "minify" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcDrawer_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcDrawer.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcDrawer = __decorate([
    ProxyCmp({
        inputs: ['hideBackdrop', 'mini', 'mode', 'placement', 'visible']
    }),
], OwcDrawer);
let OwcEditableDropdown = class OwcEditableDropdown {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selectChange', 'panelOpen', 'panelClose', 'inputKeyDown']);
    }
};
OwcEditableDropdown.ɵfac = function OwcEditableDropdown_Factory(t) { return new (t || OwcEditableDropdown)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcEditableDropdown.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcEditableDropdown, selectors: [["owc-editable-dropdown"]], inputs: { compact: "compact", disabled: "disabled", label: "label", limit: "limit", name: "name", notFoundText: "notFoundText", placeholder: "placeholder", popoverStyle: "popoverStyle", required: "required", requiredText: "requiredText", variant: "variant" }, outputs: { selectChange: "selectChange", panelOpen: "panelOpen", panelClose: "panelClose", inputKeyDown: "inputKeyDown" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcEditableDropdown_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcEditableDropdown.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcEditableDropdown = __decorate([
    ProxyCmp({
        inputs: ['compact', 'disabled', 'label', 'limit', 'name', 'notFoundText', 'placeholder', 'popoverStyle', 'required', 'requiredText', 'variant'],
        methods: ['getPopoverElement']
    }),
], OwcEditableDropdown);
let OwcExpandable = class OwcExpandable {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['statusChanged']);
    }
};
OwcExpandable.ɵfac = function OwcExpandable_Factory(t) { return new (t || OwcExpandable)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcExpandable.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcExpandable, selectors: [["owc-expandable"]], inputs: { disabled: "disabled", expanded: "expanded", round: "round", variant: "variant" }, outputs: { statusChanged: "statusChanged" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcExpandable_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcExpandable.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcExpandable = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'expanded', 'round', 'variant']
    }),
], OwcExpandable);
let OwcExpandableGroup = class OwcExpandableGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['expandedElementsChanged']);
    }
};
OwcExpandableGroup.ɵfac = function OwcExpandableGroup_Factory(t) { return new (t || OwcExpandableGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcExpandableGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcExpandableGroup, selectors: [["owc-expandable-group"]], inputs: { multiple: "multiple" }, outputs: { expandedElementsChanged: "expandedElementsChanged" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcExpandableGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcExpandableGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcExpandableGroup = __decorate([
    ProxyCmp({
        inputs: ['multiple'],
        methods: ['setAllState']
    }),
], OwcExpandableGroup);
let OwcFilteringChip = class OwcFilteringChip {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selectChange', 'panelOpen', 'panelClose']);
    }
};
OwcFilteringChip.ɵfac = function OwcFilteringChip_Factory(t) { return new (t || OwcFilteringChip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcFilteringChip.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcFilteringChip, selectors: [["owc-filtering-chip"]], inputs: { applyButtonText: "applyButtonText", disableRipple: "disableRipple", label: "label", limit: "limit", placeholder: "placeholder", selectAllText: "selectAllText" }, outputs: { selectChange: "selectChange", panelOpen: "panelOpen", panelClose: "panelClose" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcFilteringChip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcFilteringChip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcFilteringChip = __decorate([
    ProxyCmp({
        inputs: ['applyButtonText', 'disableRipple', 'label', 'limit', 'placeholder', 'selectAllText'],
        methods: ['getSelectedItems']
    }),
], OwcFilteringChip);
let OwcFooter = class OwcFooter {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcFooter.ɵfac = function OwcFooter_Factory(t) { return new (t || OwcFooter)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcFooter.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcFooter, selectors: [["owc-footer"]], inputs: { fixBottom: "fixBottom" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcFooter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcFooter.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcFooter = __decorate([
    ProxyCmp({
        inputs: ['fixBottom']
    }),
], OwcFooter);
let OwcForm = class OwcForm {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['formSubmit']);
    }
};
OwcForm.ɵfac = function OwcForm_Factory(t) { return new (t || OwcForm)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcForm.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcForm, selectors: [["owc-form"]], inputs: { action: "action", method: "method", target: "target" }, outputs: { formSubmit: "formSubmit" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcForm_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcForm.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcForm = __decorate([
    ProxyCmp({
        inputs: ['action', 'method', 'target']
    }),
], OwcForm);
let OwcGrid = class OwcGrid {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcGrid.ɵfac = function OwcGrid_Factory(t) { return new (t || OwcGrid)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcGrid.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcGrid, selectors: [["owc-grid"]], inputs: { columns: "columns", container: "container", hGutter: "hGutter", item: "item", l: "l", m: "m", padding: "padding", s: "s", vGutter: "vGutter", xl: "xl", xs: "xs" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcGrid_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcGrid.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcGrid = __decorate([
    ProxyCmp({
        inputs: ['columns', 'container', 'hGutter', 'item', 'l', 'm', 'padding', 's', 'vGutter', 'xl', 'xs']
    }),
], OwcGrid);
let OwcHorizontalStep = class OwcHorizontalStep {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcHorizontalStep.ɵfac = function OwcHorizontalStep_Factory(t) { return new (t || OwcHorizontalStep)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcHorizontalStep.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcHorizontalStep, selectors: [["owc-horizontal-step"]], inputs: { active: "active", completed: "completed", condensed: "condensed", disabled: "disabled", linear: "linear", number: "number", optionalText: "optionalText" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcHorizontalStep_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcHorizontalStep.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcHorizontalStep = __decorate([
    ProxyCmp({
        inputs: ['active', 'completed', 'condensed', 'disabled', 'linear', 'number', 'optionalText']
    }),
], OwcHorizontalStep);
let OwcHorizontalStepper = class OwcHorizontalStepper {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['stepChanged']);
    }
};
OwcHorizontalStepper.ɵfac = function OwcHorizontalStepper_Factory(t) { return new (t || OwcHorizontalStepper)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcHorizontalStepper.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcHorizontalStepper, selectors: [["owc-horizontal-stepper"]], inputs: { activeStep: "activeStep", condensed: "condensed", linear: "linear" }, outputs: { stepChanged: "stepChanged" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcHorizontalStepper_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcHorizontalStepper.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcHorizontalStepper = __decorate([
    ProxyCmp({
        inputs: ['activeStep', 'condensed', 'linear']
    }),
], OwcHorizontalStepper);
let OwcHyperlink = class OwcHyperlink {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcHyperlink.ɵfac = function OwcHyperlink_Factory(t) { return new (t || OwcHyperlink)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcHyperlink.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcHyperlink, selectors: [["owc-hyperlink"]], inputs: { href: "href", prose: "prose", rel: "rel", target: "target" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcHyperlink_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcHyperlink.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcHyperlink = __decorate([
    ProxyCmp({
        inputs: ['href', 'prose', 'rel', 'target']
    }),
], OwcHyperlink);
let OwcIcon = class OwcIcon {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcIcon.ɵfac = function OwcIcon_Factory(t) { return new (t || OwcIcon)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcIcon.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcIcon, selectors: [["owc-icon"]], inputs: { name: "name", type: "type", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcIcon.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcIcon = __decorate([
    ProxyCmp({
        inputs: ['name', 'type', 'variant']
    }),
], OwcIcon);
let OwcIconButton = class OwcIconButton {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcIconButton.ɵfac = function OwcIconButton_Factory(t) { return new (t || OwcIconButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcIconButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcIconButton, selectors: [["owc-icon-button"]], inputs: { disableRipple: "disableRipple", disabled: "disabled", flat: "flat", icon: "icon", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcIconButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcIconButton.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcIconButton = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'disabled', 'flat', 'icon', 'type']
    }),
], OwcIconButton);
let OwcInput = class OwcInput {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputChange', 'inputKeyDown']);
    }
};
OwcInput.ɵfac = function OwcInput_Factory(t) { return new (t || OwcInput)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcInput.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcInput, selectors: [["owc-input"]], inputs: { autoFocus: "autoFocus", compact: "compact", disabled: "disabled", error: "error", focusedView: "focusedView", label: "label", max: "max", maxLength: "maxLength", min: "min", minLength: "minLength", name: "name", pattern: "pattern", placeholder: "placeholder", required: "required", round: "round", selectionEnd: "selectionEnd", selectionStart: "selectionStart", type: "type", value: "value", variant: "variant" }, outputs: { inputChange: "inputChange", inputKeyDown: "inputKeyDown" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcInput_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcInput.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcInput = __decorate([
    ProxyCmp({
        inputs: ['autoFocus', 'compact', 'disabled', 'error', 'focusedView', 'label', 'max', 'maxLength', 'min', 'minLength', 'name', 'pattern', 'placeholder', 'required', 'round', 'selectionEnd', 'selectionStart', 'type', 'value', 'variant'],
        methods: ['setFocused']
    }),
], OwcInput);
let OwcList = class OwcList {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selectChange']);
    }
};
OwcList.ɵfac = function OwcList_Factory(t) { return new (t || OwcList)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcList.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcList, selectors: [["owc-list"]], inputs: { handleOnFocus: "handleOnFocus", multiple: "multiple", size: "size" }, outputs: { selectChange: "selectChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcList_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcList.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcList = __decorate([
    ProxyCmp({
        inputs: ['handleOnFocus', 'multiple', 'size']
    }),
], OwcList);
let OwcListItem = class OwcListItem {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcListItem.ɵfac = function OwcListItem_Factory(t) { return new (t || OwcListItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcListItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcListItem, selectors: [["owc-list-item"]], inputs: { disableRipple: "disableRipple", disabled: "disabled", drawer: "drawer", icon: "icon", iconType: "iconType", indent: "indent", noBorder: "noBorder", secondaryText: "secondaryText", selected: "selected", size: "size", tooltipPlacement: "tooltipPlacement" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcListItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcListItem.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcListItem = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'disabled', 'drawer', 'icon', 'iconType', 'indent', 'noBorder', 'secondaryText', 'selected', 'size', 'tooltipPlacement']
    }),
], OwcListItem);
let OwcMenu = class OwcMenu {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['visibleChange', 'clickOutside']);
    }
};
OwcMenu.ɵfac = function OwcMenu_Factory(t) { return new (t || OwcMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcMenu.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcMenu, selectors: [["owc-menu"]], inputs: { alignment: "alignment", anchor: "anchor", autoUnportal: "autoUnportal", disablePortal: "disablePortal", limit: "limit", offset: "offset", scrollPadding: "scrollPadding", strategy: "strategy", verticalPlacement: "verticalPlacement", visible: "visible" }, outputs: { visibleChange: "visibleChange", clickOutside: "clickOutside" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcMenu.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcMenu = __decorate([
    ProxyCmp({
        inputs: ['alignment', 'anchor', 'autoUnportal', 'disablePortal', 'limit', 'offset', 'scrollPadding', 'strategy', 'verticalPlacement', 'visible'],
        methods: ['reArrangeMenuHeight']
    }),
], OwcMenu);
let OwcModalDialog = class OwcModalDialog {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['visibleChange']);
    }
};
OwcModalDialog.ɵfac = function OwcModalDialog_Factory(t) { return new (t || OwcModalDialog)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcModalDialog.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcModalDialog, selectors: [["owc-modal-dialog"]], inputs: { denseContent: "denseContent", disableBackdropClick: "disableBackdropClick", disableEscapeKeydown: "disableEscapeKeydown", disableScrollLock: "disableScrollLock", hideBackdrop: "hideBackdrop", size: "size", visible: "visible", width: "width" }, outputs: { visibleChange: "visibleChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcModalDialog_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcModalDialog.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcModalDialog = __decorate([
    ProxyCmp({
        inputs: ['denseContent', 'disableBackdropClick', 'disableEscapeKeydown', 'disableScrollLock', 'hideBackdrop', 'size', 'visible', 'width']
    }),
], OwcModalDialog);
let OwcNotificationDrawer = class OwcNotificationDrawer {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcNotificationDrawer.ɵfac = function OwcNotificationDrawer_Factory(t) { return new (t || OwcNotificationDrawer)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcNotificationDrawer.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcNotificationDrawer, selectors: [["owc-notification-drawer"]], inputs: { limit: "limit" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcNotificationDrawer_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcNotificationDrawer.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcNotificationDrawer = __decorate([
    ProxyCmp({
        inputs: ['limit'],
        methods: ['addChild']
    }),
], OwcNotificationDrawer);
let OwcPagination = class OwcPagination {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['pageChange']);
    }
};
OwcPagination.ɵfac = function OwcPagination_Factory(t) { return new (t || OwcPagination)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcPagination.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcPagination, selectors: [["owc-pagination"]], inputs: { options: "options", page: "page", rowsPerPage: "rowsPerPage", showPerPage: "showPerPage", total: "total" }, outputs: { pageChange: "pageChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcPagination_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcPagination.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcPagination = __decorate([
    ProxyCmp({
        inputs: ['options', 'page', 'rowsPerPage', 'showPerPage', 'total']
    }),
], OwcPagination);
let OwcPopover = class OwcPopover {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['visibleChange', 'clickOutside']);
    }
};
OwcPopover.ɵfac = function OwcPopover_Factory(t) { return new (t || OwcPopover)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcPopover.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcPopover, selectors: [["owc-popover"]], inputs: { anchor: "anchor", anchorPosition: "anchorPosition", autoUnportal: "autoUnportal", disablePortal: "disablePortal", offset: "offset", strategy: "strategy", visible: "visible" }, outputs: { visibleChange: "visibleChange", clickOutside: "clickOutside" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcPopover_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcPopover.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcPopover = __decorate([
    ProxyCmp({
        inputs: ['anchor', 'anchorPosition', 'autoUnportal', 'disablePortal', 'offset', 'strategy', 'visible']
    }),
], OwcPopover);
let OwcProgressBar = class OwcProgressBar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcProgressBar.ɵfac = function OwcProgressBar_Factory(t) { return new (t || OwcProgressBar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcProgressBar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcProgressBar, selectors: [["owc-progress-bar"]], inputs: { caption: "caption", mode: "mode", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcProgressBar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcProgressBar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcProgressBar = __decorate([
    ProxyCmp({
        inputs: ['caption', 'mode', 'value']
    }),
], OwcProgressBar);
let OwcProgressSpinner = class OwcProgressSpinner {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcProgressSpinner.ɵfac = function OwcProgressSpinner_Factory(t) { return new (t || OwcProgressSpinner)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcProgressSpinner.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcProgressSpinner, selectors: [["owc-progress-spinner"]], inputs: { diameter: "diameter", mode: "mode", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcProgressSpinner_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcProgressSpinner.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcProgressSpinner = __decorate([
    ProxyCmp({
        inputs: ['diameter', 'mode', 'value']
    }),
], OwcProgressSpinner);
let OwcRadio = class OwcRadio {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputChange']);
    }
};
OwcRadio.ɵfac = function OwcRadio_Factory(t) { return new (t || OwcRadio)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcRadio.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcRadio, selectors: [["owc-radio"]], inputs: { checked: "checked", disableRipple: "disableRipple", disabled: "disabled", labelPlacement: "labelPlacement", name: "name", value: "value" }, outputs: { inputChange: "inputChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcRadio_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcRadio.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcRadio = __decorate([
    ProxyCmp({
        inputs: ['checked', 'disableRipple', 'disabled', 'labelPlacement', 'name', 'value']
    }),
], OwcRadio);
let OwcRadioGroup = class OwcRadioGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputChange']);
    }
};
OwcRadioGroup.ɵfac = function OwcRadioGroup_Factory(t) { return new (t || OwcRadioGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcRadioGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcRadioGroup, selectors: [["owc-radio-group"]], inputs: { disabled: "disabled", name: "name", value: "value" }, outputs: { inputChange: "inputChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcRadioGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcRadioGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcRadioGroup = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'name', 'value']
    }),
], OwcRadioGroup);
let OwcSelectDropdown = class OwcSelectDropdown {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selectChange', 'panelOpen', 'panelClose']);
    }
};
OwcSelectDropdown.ɵfac = function OwcSelectDropdown_Factory(t) { return new (t || OwcSelectDropdown)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSelectDropdown.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSelectDropdown, selectors: [["owc-select-dropdown"]], inputs: { disabled: "disabled", label: "label", limit: "limit", multiple: "multiple", name: "name", outlined: "outlined", placeholder: "placeholder", popoverStyle: "popoverStyle", required: "required", requiredText: "requiredText", selectAllText: "selectAllText", size: "size" }, outputs: { selectChange: "selectChange", panelOpen: "panelOpen", panelClose: "panelClose" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSelectDropdown_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSelectDropdown.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSelectDropdown = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'label', 'limit', 'multiple', 'name', 'outlined', 'placeholder', 'popoverStyle', 'required', 'requiredText', 'selectAllText', 'size'],
        methods: ['getSelectedItems', 'getPopoverElement']
    }),
], OwcSelectDropdown);
let OwcSkeletonLoader = class OwcSkeletonLoader {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcSkeletonLoader.ɵfac = function OwcSkeletonLoader_Factory(t) { return new (t || OwcSkeletonLoader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSkeletonLoader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSkeletonLoader, selectors: [["owc-skeleton-loader"]], inputs: { animation: "animation", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSkeletonLoader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSkeletonLoader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSkeletonLoader = __decorate([
    ProxyCmp({
        inputs: ['animation', 'variant']
    }),
], OwcSkeletonLoader);
let OwcSlideToggle = class OwcSlideToggle {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputChange']);
    }
};
OwcSlideToggle.ɵfac = function OwcSlideToggle_Factory(t) { return new (t || OwcSlideToggle)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSlideToggle.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSlideToggle, selectors: [["owc-slide-toggle"]], inputs: { checked: "checked", disableRipple: "disableRipple", disabled: "disabled", labelPlacement: "labelPlacement" }, outputs: { inputChange: "inputChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSlideToggle_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSlideToggle.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSlideToggle = __decorate([
    ProxyCmp({
        inputs: ['checked', 'disableRipple', 'disabled', 'labelPlacement']
    }),
], OwcSlideToggle);
let OwcSlider = class OwcSlider {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['valueChange']);
    }
};
OwcSlider.ɵfac = function OwcSlider_Factory(t) { return new (t || OwcSlider)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSlider.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSlider, selectors: [["owc-slider"]], inputs: { disabled: "disabled", inverted: "inverted", max: "max", min: "min", shiftValue: "shiftValue", showTicks: "showTicks", showValueLabel: "showValueLabel", step: "step", tickIntervals: "tickIntervals", value: "value", vertical: "vertical" }, outputs: { valueChange: "valueChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSlider_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSlider.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSlider = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'inverted', 'max', 'min', 'shiftValue', 'showTicks', 'showValueLabel', 'step', 'tickIntervals', 'value', 'vertical']
    }),
], OwcSlider);
let OwcSliderMarker = class OwcSliderMarker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcSliderMarker.ɵfac = function OwcSliderMarker_Factory(t) { return new (t || OwcSliderMarker)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSliderMarker.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSliderMarker, selectors: [["owc-slider-marker"]], inputs: { disabled: "disabled", selected: "selected", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSliderMarker_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSliderMarker.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSliderMarker = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'selected', 'value']
    }),
], OwcSliderMarker);
let OwcSnackbar = class OwcSnackbar {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['actionBtn', 'open', 'close']);
    }
};
OwcSnackbar.ɵfac = function OwcSnackbar_Factory(t) { return new (t || OwcSnackbar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSnackbar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSnackbar, selectors: [["owc-snackbar"]], inputs: { action: "action", content: "content", duration: "duration", horizontalPlacement: "horizontalPlacement", htmlContent: "htmlContent", type: "type", verticalPlacement: "verticalPlacement" }, outputs: { actionBtn: "actionBtn", open: "open", close: "close" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSnackbar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSnackbar.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSnackbar = __decorate([
    ProxyCmp({
        inputs: ['action', 'content', 'duration', 'horizontalPlacement', 'htmlContent', 'type', 'verticalPlacement'],
        methods: ['hide']
    }),
], OwcSnackbar);
let OwcSplitScreen = class OwcSplitScreen {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['sizeChange']);
    }
};
OwcSplitScreen.ɵfac = function OwcSplitScreen_Factory(t) { return new (t || OwcSplitScreen)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcSplitScreen.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcSplitScreen, selectors: [["owc-split-screen"]], inputs: { disabled: "disabled", size: "size", vertical: "vertical" }, outputs: { sizeChange: "sizeChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcSplitScreen_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcSplitScreen.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcSplitScreen = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'size', 'vertical']
    }),
], OwcSplitScreen);
let OwcTab = class OwcTab {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcTab.ɵfac = function OwcTab_Factory(t) { return new (t || OwcTab)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTab.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTab, selectors: [["owc-tab"]], inputs: { disableRipple: "disableRipple", selected: "selected", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTab_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTab.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTab = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'selected', 'value']
    }),
], OwcTab);
let OwcTable = class OwcTable {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcTable.ɵfac = function OwcTable_Factory(t) { return new (t || OwcTable)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTable.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTable, selectors: [["owc-table"]], inputs: { disableScroll: "disableScroll", dragEnabled: "dragEnabled", height: "height", scrollHideTimeout: "scrollHideTimeout", spacing: "spacing", stickyColumn: "stickyColumn" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTable_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTable.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTable = __decorate([
    ProxyCmp({
        inputs: ['disableScroll', 'dragEnabled', 'height', 'scrollHideTimeout', 'spacing', 'stickyColumn']
    }),
], OwcTable);
let OwcTableBody = class OwcTableBody {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcTableBody.ɵfac = function OwcTableBody_Factory(t) { return new (t || OwcTableBody)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableBody.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableBody, selectors: [["owc-table-body"]], inputs: { dragEnabled: "dragEnabled", loading: "loading" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableBody_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableBody.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableBody = __decorate([
    ProxyCmp({
        inputs: ['dragEnabled', 'loading']
    }),
], OwcTableBody);
let OwcTableCell = class OwcTableCell {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['contentChange', 'editModeChange']);
    }
};
OwcTableCell.ɵfac = function OwcTableCell_Factory(t) { return new (t || OwcTableCell)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableCell.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableCell, selectors: [["owc-table-cell"]], inputs: { align: "align", editable: "editable", editing: "editing", spacing: "spacing", sticky: "sticky", valign: "valign" }, outputs: { contentChange: "contentChange", editModeChange: "editModeChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableCell_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableCell.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableCell = __decorate([
    ProxyCmp({
        inputs: ['align', 'editable', 'editing', 'spacing', 'sticky', 'valign']
    }),
], OwcTableCell);
let OwcTableGroup = class OwcTableGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['expandChange']);
    }
};
OwcTableGroup.ɵfac = function OwcTableGroup_Factory(t) { return new (t || OwcTableGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableGroup, selectors: [["owc-table-group"]], inputs: { expandable: "expandable", expanded: "expanded", hasCheckbox: "hasCheckbox", header: "header", indentation: "indentation", leadingExpandableCol: "leadingExpandableCol", spacing: "spacing", stickyColumn: "stickyColumn" }, outputs: { expandChange: "expandChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableGroup = __decorate([
    ProxyCmp({
        inputs: ['expandable', 'expanded', 'hasCheckbox', 'header', 'indentation', 'leadingExpandableCol', 'spacing', 'stickyColumn']
    }),
], OwcTableGroup);
let OwcTableHeader = class OwcTableHeader {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['columnWidthsChange', 'selectAllStateChange', 'columnResize']);
    }
};
OwcTableHeader.ɵfac = function OwcTableHeader_Factory(t) { return new (t || OwcTableHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableHeader, selectors: [["owc-table-header"]], inputs: { checboxState: "checboxState", elevated: "elevated", hasCheckbox: "hasCheckbox", indentation: "indentation", leadingExpandableCol: "leadingExpandableCol", shrink: "shrink", spacing: "spacing", sticky: "sticky", stickyColumn: "stickyColumn", trailingExpandableCol: "trailingExpandableCol" }, outputs: { columnWidthsChange: "columnWidthsChange", selectAllStateChange: "selectAllStateChange", columnResize: "columnResize" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableHeader.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableHeader = __decorate([
    ProxyCmp({
        inputs: ['checboxState', 'elevated', 'hasCheckbox', 'indentation', 'leadingExpandableCol', 'shrink', 'spacing', 'sticky', 'stickyColumn', 'trailingExpandableCol']
    }),
], OwcTableHeader);
let OwcTableHeaderCell = class OwcTableHeaderCell {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['sortChange']);
    }
};
OwcTableHeaderCell.ɵfac = function OwcTableHeaderCell_Factory(t) { return new (t || OwcTableHeaderCell)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableHeaderCell.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableHeaderCell, selectors: [["owc-table-header-cell"]], inputs: { align: "align", noClip: "noClip", resizable: "resizable", sortOrder: "sortOrder", sortable: "sortable", spacing: "spacing", sticky: "sticky", valign: "valign", width: "width" }, outputs: { sortChange: "sortChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableHeaderCell_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableHeaderCell.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableHeaderCell = __decorate([
    ProxyCmp({
        inputs: ['align', 'noClip', 'resizable', 'sortOrder', 'sortable', 'spacing', 'sticky', 'valign', 'width']
    }),
], OwcTableHeaderCell);
let OwcTableRow = class OwcTableRow {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selectChange', 'expandChange', 'indexChange']);
    }
};
OwcTableRow.ɵfac = function OwcTableRow_Factory(t) { return new (t || OwcTableRow)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableRow.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableRow, selectors: [["owc-table-row"]], inputs: { columnWidths: "columnWidths", disabled: "disabled", expandable: "expandable", expanded: "expanded", hasCheckbox: "hasCheckbox", indentation: "indentation", locked: "locked", selectable: "selectable", selected: "selected", spacing: "spacing", stickyColumn: "stickyColumn" }, outputs: { selectChange: "selectChange", expandChange: "expandChange", indexChange: "indexChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableRow_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableRow.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableRow = __decorate([
    ProxyCmp({
        inputs: ['columnWidths', 'disabled', 'expandable', 'expanded', 'hasCheckbox', 'indentation', 'locked', 'selectable', 'selected', 'spacing', 'stickyColumn']
    }),
], OwcTableRow);
let OwcTableSpacingDialog = class OwcTableSpacingDialog {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['dialogOpen', 'dialogClose', 'apply']);
    }
};
OwcTableSpacingDialog.ɵfac = function OwcTableSpacingDialog_Factory(t) { return new (t || OwcTableSpacingDialog)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTableSpacingDialog.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTableSpacingDialog, selectors: [["owc-table-spacing-dialog"]], inputs: { applyButtonText: "applyButtonText", closeButtonText: "closeButtonText", compactHeading: "compactHeading", contentTitle: "contentTitle", defaultHeading: "defaultHeading", denseFootnote: "denseFootnote", denseHeading: "denseHeading", header: "header", spacing: "spacing", visible: "visible" }, outputs: { dialogOpen: "dialogOpen", dialogClose: "dialogClose", apply: "apply" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTableSpacingDialog_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTableSpacingDialog.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTableSpacingDialog = __decorate([
    ProxyCmp({
        inputs: ['applyButtonText', 'closeButtonText', 'compactHeading', 'contentTitle', 'defaultHeading', 'denseFootnote', 'denseHeading', 'header', 'spacing', 'visible']
    }),
], OwcTableSpacingDialog);
let OwcTabs = class OwcTabs {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['tabChange']);
    }
};
OwcTabs.ɵfac = function OwcTabs_Factory(t) { return new (t || OwcTabs)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTabs.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTabs, selectors: [["owc-tabs"]], inputs: { disableRipple: "disableRipple", value: "value" }, outputs: { tabChange: "tabChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTabs_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTabs.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTabs = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'value']
    }),
], OwcTabs);
let OwcTextarea = class OwcTextarea {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputChange', 'inputKeyDown', 'inputReset']);
    }
};
OwcTextarea.ɵfac = function OwcTextarea_Factory(t) { return new (t || OwcTextarea)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTextarea.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTextarea, selectors: [["owc-textarea"]], inputs: { assistiveText: "assistiveText", cols: "cols", disabled: "disabled", errorText: "errorText", label: "label", maxLength: "maxLength", minLength: "minLength", placeholder: "placeholder", required: "required", reset: "reset", resizable: "resizable", rows: "rows", validationMode: "validationMode", validator: "validator", value: "value", variant: "variant" }, outputs: { inputChange: "inputChange", inputKeyDown: "inputKeyDown", inputReset: "inputReset" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTextarea_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTextarea.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTextarea = __decorate([
    ProxyCmp({
        inputs: ['assistiveText', 'cols', 'disabled', 'errorText', 'label', 'maxLength', 'minLength', 'placeholder', 'required', 'reset', 'resizable', 'rows', 'validationMode', 'validator', 'value', 'variant']
    }),
], OwcTextarea);
let OwcTimepicker = class OwcTimepicker {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['panelOpen', 'panelClose', 'valueChange']);
    }
};
OwcTimepicker.ɵfac = function OwcTimepicker_Factory(t) { return new (t || OwcTimepicker)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTimepicker.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTimepicker, selectors: [["owc-timepicker"]], inputs: { compact: "compact", disabled: "disabled", format: "format", hasClearIcon: "hasClearIcon", invalidTimeMessage: "invalidTimeMessage", label: "label", locale: "locale", maxTime: "maxTime", maxTimeMessage: "maxTimeMessage", minTime: "minTime", minTimeMessage: "minTimeMessage", name: "name", native: "native", placeholder: "placeholder", popoverStyle: "popoverStyle", required: "required", requiredTimeMessage: "requiredTimeMessage", selectOutOfStep: "selectOutOfStep", step: "step", unavailable: "unavailable", value: "value", variant: "variant" }, outputs: { panelOpen: "panelOpen", panelClose: "panelClose", valueChange: "valueChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTimepicker_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTimepicker.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTimepicker = __decorate([
    ProxyCmp({
        inputs: ['compact', 'disabled', 'format', 'hasClearIcon', 'invalidTimeMessage', 'label', 'locale', 'maxTime', 'maxTimeMessage', 'minTime', 'minTimeMessage', 'name', 'native', 'placeholder', 'popoverStyle', 'required', 'requiredTimeMessage', 'selectOutOfStep', 'step', 'unavailable', 'value', 'variant'],
        methods: ['getPopoverElement']
    }),
], OwcTimepicker);
let OwcToggleButton = class OwcToggleButton {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcToggleButton.ɵfac = function OwcToggleButton_Factory(t) { return new (t || OwcToggleButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcToggleButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcToggleButton, selectors: [["owc-toggle-button"]], inputs: { disableRipple: "disableRipple", disabled: "disabled", selected: "selected" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcToggleButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcToggleButton.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcToggleButton = __decorate([
    ProxyCmp({
        inputs: ['disableRipple', 'disabled', 'selected']
    }),
], OwcToggleButton);
let OwcToggleButtonGroup = class OwcToggleButtonGroup {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['selectChange']);
    }
};
OwcToggleButtonGroup.ɵfac = function OwcToggleButtonGroup_Factory(t) { return new (t || OwcToggleButtonGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcToggleButtonGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcToggleButtonGroup, selectors: [["owc-toggle-button-group"]], inputs: { disabled: "disabled", flat: "flat", round: "round" }, outputs: { selectChange: "selectChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcToggleButtonGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcToggleButtonGroup.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcToggleButtonGroup = __decorate([
    ProxyCmp({
        inputs: ['disabled', 'flat', 'round']
    }),
], OwcToggleButtonGroup);
let OwcTooltip = class OwcTooltip {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['visibleChange', 'clickOutside']);
    }
};
OwcTooltip.ɵfac = function OwcTooltip_Factory(t) { return new (t || OwcTooltip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTooltip.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTooltip, selectors: [["owc-tooltip"]], inputs: { anchor: "anchor", autoUnportal: "autoUnportal", disablePortal: "disablePortal", disableTriggers: "disableTriggers", enterDelay: "enterDelay", leaveDelay: "leaveDelay", offset: "offset", placement: "placement", strategy: "strategy", visible: "visible" }, outputs: { visibleChange: "visibleChange", clickOutside: "clickOutside" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTooltip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTooltip.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTooltip = __decorate([
    ProxyCmp({
        inputs: ['anchor', 'autoUnportal', 'disablePortal', 'disableTriggers', 'enterDelay', 'leaveDelay', 'offset', 'placement', 'strategy', 'visible']
    }),
], OwcTooltip);
let OwcTypography = class OwcTypography {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcTypography.ɵfac = function OwcTypography_Factory(t) { return new (t || OwcTypography)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcTypography.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcTypography, selectors: [["owc-typography"]], inputs: { element: "element", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcTypography_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcTypography.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcTypography = __decorate([
    ProxyCmp({
        inputs: ['element', 'variant']
    }),
], OwcTypography);
let OwcVerticalStep = class OwcVerticalStep {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
OwcVerticalStep.ɵfac = function OwcVerticalStep_Factory(t) { return new (t || OwcVerticalStep)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcVerticalStep.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcVerticalStep, selectors: [["owc-vertical-step"]], inputs: { active: "active", completed: "completed", disabled: "disabled", linear: "linear", step: "step" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcVerticalStep_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcVerticalStep.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcVerticalStep = __decorate([
    ProxyCmp({
        inputs: ['active', 'completed', 'disabled', 'linear', 'step']
    }),
], OwcVerticalStep);
let OwcVerticalStepper = class OwcVerticalStepper {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['stepChanged']);
    }
};
OwcVerticalStepper.ɵfac = function OwcVerticalStepper_Factory(t) { return new (t || OwcVerticalStepper)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcVerticalStepper.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcVerticalStepper, selectors: [["owc-vertical-stepper"]], inputs: { activeStep: "activeStep", linear: "linear", numbered: "numbered" }, outputs: { stepChanged: "stepChanged" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcVerticalStepper_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcVerticalStepper.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcVerticalStepper = __decorate([
    ProxyCmp({
        inputs: ['activeStep', 'linear', 'numbered']
    }),
], OwcVerticalStepper);
let OwcWorkflowOverlay = class OwcWorkflowOverlay {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['visibleChange']);
    }
};
OwcWorkflowOverlay.ɵfac = function OwcWorkflowOverlay_Factory(t) { return new (t || OwcWorkflowOverlay)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OwcWorkflowOverlay.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwcWorkflowOverlay, selectors: [["owc-workflow-overlay"]], inputs: { height: "height", visible: "visible", width: "width" }, outputs: { visibleChange: "visibleChange" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwcWorkflowOverlay_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
OwcWorkflowOverlay.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
OwcWorkflowOverlay = __decorate([
    ProxyCmp({
        inputs: ['height', 'visible', 'width']
    }),
], OwcWorkflowOverlay);

const COMPONENTS = [
    InternalLifecycleActivator,
    OwcAvatar,
    OwcBackdrop,
    OwcBadge,
    OwcBanner,
    OwcBottomNav,
    OwcBottomNavItem,
    OwcBreadcrumb,
    OwcBreadcrumbItem,
    OwcButton,
    OwcCalendar,
    OwcCard,
    OwcCheckbox,
    OwcChip,
    OwcCookieAcceptance,
    OwcCookieAcceptanceOption,
    OwcDatepicker,
    OwcDatepickerYearItem,
    OwcDivider,
    OwcDoubleGlobalArea,
    OwcDrawer,
    OwcEditableDropdown,
    OwcExpandable,
    OwcExpandableGroup,
    OwcFilteringChip,
    OwcFooter,
    OwcForm,
    OwcGrid,
    OwcHorizontalStep,
    OwcHorizontalStepper,
    OwcHyperlink,
    OwcIcon,
    OwcIconButton,
    OwcInput,
    OwcList,
    OwcListItem,
    OwcMenu,
    OwcModalDialog,
    OwcNotificationDrawer,
    OwcPagination,
    OwcPopover,
    OwcProgressBar,
    OwcProgressSpinner,
    OwcRadio,
    OwcRadioGroup,
    OwcSelectDropdown,
    OwcSkeletonLoader,
    OwcSlideToggle,
    OwcSlider,
    OwcSliderMarker,
    OwcSnackbar,
    OwcSplitScreen,
    OwcTab,
    OwcTable,
    OwcTableBody,
    OwcTableCell,
    OwcTableGroup,
    OwcTableHeader,
    OwcTableHeaderCell,
    OwcTableRow,
    OwcTableSpacingDialog,
    OwcTabs,
    OwcTextarea,
    OwcTimepicker,
    OwcToggleButton,
    OwcToggleButtonGroup,
    OwcTooltip,
    OwcTypography,
    OwcVerticalStep,
    OwcVerticalStepper,
    OwcWorkflowOverlay
];

var OwcBottomNavAccessor_1, OwcCheckboxAccessor_1, OwcDatepickerAccessor_1, OwcDrawerAccessor_1, OwcExpandableAccessor_1, OwcHorizontalStepperAccessor_1, OwcInputAccessor_1, OwcMenuAccessor_1, OwcModalDialogAccessor_1, OwcRadioAccessor_1, OwcRadioGroupAccessor_1, OwcSlideToggleAccessor_1, OwcSliderAccessor_1, OwcSplitScreenAccessor_1, OwcTabsAccessor_1, OwcTextareaAccessor_1, OwcTimepickerAccessor_1, OwcTooltipAccessor_1, OwcVerticalStepperAccessor_1, OwcWorkflowOverlayAccessor_1;
let OwcBottomNavAccessor = OwcBottomNavAccessor_1 = class OwcBottomNavAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcBottomNavAccessor.ɵfac = function OwcBottomNavAccessor_Factory(t) { return new (t || OwcBottomNavAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcBottomNavAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcBottomNavAccessor, selectors: [["owc-bottom-nav"]], hostBindings: function OwcBottomNavAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("bottomNavChange", function OwcBottomNavAccessor_bottomNavChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcBottomNavAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcBottomNavAccessor_1),
                multi: true
            }
        ])] });
OwcBottomNavAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcBottomNavAccessor.prototype, "_handleBlurEvent", null);
let OwcCheckboxAccessor = OwcCheckboxAccessor_1 = class OwcCheckboxAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('checked', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcCheckboxAccessor.ɵfac = function OwcCheckboxAccessor_Factory(t) { return new (t || OwcCheckboxAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcCheckboxAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcCheckboxAccessor, selectors: [["owc-checkbox"]], hostBindings: function OwcCheckboxAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("inputChange", function OwcCheckboxAccessor_inputChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcCheckboxAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcCheckboxAccessor_1),
                multi: true
            }
        ])] });
OwcCheckboxAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcCheckboxAccessor.prototype, "_handleBlurEvent", null);
let OwcDatepickerAccessor = OwcDatepickerAccessor_1 = class OwcDatepickerAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcDatepickerAccessor.ɵfac = function OwcDatepickerAccessor_Factory(t) { return new (t || OwcDatepickerAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcDatepickerAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcDatepickerAccessor, selectors: [["owc-datepicker"]], hostBindings: function OwcDatepickerAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("valueChange", function OwcDatepickerAccessor_valueChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcDatepickerAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcDatepickerAccessor_1),
                multi: true
            }
        ])] });
OwcDatepickerAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcDatepickerAccessor.prototype, "_handleBlurEvent", null);
let OwcDrawerAccessor = OwcDrawerAccessor_1 = class OwcDrawerAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('visible', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcDrawerAccessor.ɵfac = function OwcDrawerAccessor_Factory(t) { return new (t || OwcDrawerAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcDrawerAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcDrawerAccessor, selectors: [["owc-drawer"]], hostBindings: function OwcDrawerAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("visibleChange", function OwcDrawerAccessor_visibleChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcDrawerAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcDrawerAccessor_1),
                multi: true
            }
        ])] });
OwcDrawerAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcDrawerAccessor.prototype, "_handleBlurEvent", null);
let OwcExpandableAccessor = OwcExpandableAccessor_1 = class OwcExpandableAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('expanded', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcExpandableAccessor.ɵfac = function OwcExpandableAccessor_Factory(t) { return new (t || OwcExpandableAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcExpandableAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcExpandableAccessor, selectors: [["owc-expandable"]], hostBindings: function OwcExpandableAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("statusChanged", function OwcExpandableAccessor_statusChanged_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcExpandableAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcExpandableAccessor_1),
                multi: true
            }
        ])] });
OwcExpandableAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcExpandableAccessor.prototype, "_handleBlurEvent", null);
let OwcHorizontalStepperAccessor = OwcHorizontalStepperAccessor_1 = class OwcHorizontalStepperAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('activeStep', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcHorizontalStepperAccessor.ɵfac = function OwcHorizontalStepperAccessor_Factory(t) { return new (t || OwcHorizontalStepperAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcHorizontalStepperAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcHorizontalStepperAccessor, selectors: [["owc-horizontal-stepper"]], hostBindings: function OwcHorizontalStepperAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("stepChanged", function OwcHorizontalStepperAccessor_stepChanged_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcHorizontalStepperAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcHorizontalStepperAccessor_1),
                multi: true
            }
        ])] });
OwcHorizontalStepperAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcHorizontalStepperAccessor.prototype, "_handleBlurEvent", null);
let OwcInputAccessor = OwcInputAccessor_1 = class OwcInputAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcInputAccessor.ɵfac = function OwcInputAccessor_Factory(t) { return new (t || OwcInputAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcInputAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcInputAccessor, selectors: [["owc-input"]], hostBindings: function OwcInputAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("inputChange", function OwcInputAccessor_inputChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcInputAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcInputAccessor_1),
                multi: true
            }
        ])] });
OwcInputAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcInputAccessor.prototype, "_handleBlurEvent", null);
let OwcMenuAccessor = OwcMenuAccessor_1 = class OwcMenuAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('visible', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcMenuAccessor.ɵfac = function OwcMenuAccessor_Factory(t) { return new (t || OwcMenuAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcMenuAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcMenuAccessor, selectors: [["owc-menu"]], hostBindings: function OwcMenuAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("visibleChange", function OwcMenuAccessor_visibleChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcMenuAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcMenuAccessor_1),
                multi: true
            }
        ])] });
OwcMenuAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcMenuAccessor.prototype, "_handleBlurEvent", null);
let OwcModalDialogAccessor = OwcModalDialogAccessor_1 = class OwcModalDialogAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('visible', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcModalDialogAccessor.ɵfac = function OwcModalDialogAccessor_Factory(t) { return new (t || OwcModalDialogAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcModalDialogAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcModalDialogAccessor, selectors: [["owc-modal-dialog"]], hostBindings: function OwcModalDialogAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("visibleChange", function OwcModalDialogAccessor_visibleChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcModalDialogAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcModalDialogAccessor_1),
                multi: true
            }
        ])] });
OwcModalDialogAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcModalDialogAccessor.prototype, "_handleBlurEvent", null);
let OwcRadioAccessor = OwcRadioAccessor_1 = class OwcRadioAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('checked', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcRadioAccessor.ɵfac = function OwcRadioAccessor_Factory(t) { return new (t || OwcRadioAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcRadioAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcRadioAccessor, selectors: [["owc-radio"]], hostBindings: function OwcRadioAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("inputChange", function OwcRadioAccessor_inputChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcRadioAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcRadioAccessor_1),
                multi: true
            }
        ])] });
OwcRadioAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcRadioAccessor.prototype, "_handleBlurEvent", null);
let OwcRadioGroupAccessor = OwcRadioGroupAccessor_1 = class OwcRadioGroupAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcRadioGroupAccessor.ɵfac = function OwcRadioGroupAccessor_Factory(t) { return new (t || OwcRadioGroupAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcRadioGroupAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcRadioGroupAccessor, selectors: [["owc-radio-group"]], hostBindings: function OwcRadioGroupAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("inputChange", function OwcRadioGroupAccessor_inputChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcRadioGroupAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcRadioGroupAccessor_1),
                multi: true
            }
        ])] });
OwcRadioGroupAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcRadioGroupAccessor.prototype, "_handleBlurEvent", null);
let OwcSlideToggleAccessor = OwcSlideToggleAccessor_1 = class OwcSlideToggleAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('checked', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcSlideToggleAccessor.ɵfac = function OwcSlideToggleAccessor_Factory(t) { return new (t || OwcSlideToggleAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcSlideToggleAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcSlideToggleAccessor, selectors: [["owc-slide-toggle"]], hostBindings: function OwcSlideToggleAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("inputChange", function OwcSlideToggleAccessor_inputChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcSlideToggleAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcSlideToggleAccessor_1),
                multi: true
            }
        ])] });
OwcSlideToggleAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcSlideToggleAccessor.prototype, "_handleBlurEvent", null);
let OwcSliderAccessor = OwcSliderAccessor_1 = class OwcSliderAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcSliderAccessor.ɵfac = function OwcSliderAccessor_Factory(t) { return new (t || OwcSliderAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcSliderAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcSliderAccessor, selectors: [["owc-slider"]], hostBindings: function OwcSliderAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("valueChange", function OwcSliderAccessor_valueChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcSliderAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcSliderAccessor_1),
                multi: true
            }
        ])] });
OwcSliderAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcSliderAccessor.prototype, "_handleBlurEvent", null);
let OwcSplitScreenAccessor = OwcSplitScreenAccessor_1 = class OwcSplitScreenAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('size', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcSplitScreenAccessor.ɵfac = function OwcSplitScreenAccessor_Factory(t) { return new (t || OwcSplitScreenAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcSplitScreenAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcSplitScreenAccessor, selectors: [["owc-split-screen"]], hostBindings: function OwcSplitScreenAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("sizeChange", function OwcSplitScreenAccessor_sizeChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcSplitScreenAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcSplitScreenAccessor_1),
                multi: true
            }
        ])] });
OwcSplitScreenAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcSplitScreenAccessor.prototype, "_handleBlurEvent", null);
let OwcTabsAccessor = OwcTabsAccessor_1 = class OwcTabsAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcTabsAccessor.ɵfac = function OwcTabsAccessor_Factory(t) { return new (t || OwcTabsAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcTabsAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcTabsAccessor, selectors: [["owc-tabs"]], hostBindings: function OwcTabsAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("tabChange", function OwcTabsAccessor_tabChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcTabsAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcTabsAccessor_1),
                multi: true
            }
        ])] });
OwcTabsAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcTabsAccessor.prototype, "_handleBlurEvent", null);
let OwcTextareaAccessor = OwcTextareaAccessor_1 = class OwcTextareaAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcTextareaAccessor.ɵfac = function OwcTextareaAccessor_Factory(t) { return new (t || OwcTextareaAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcTextareaAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcTextareaAccessor, selectors: [["owc-textarea"]], hostBindings: function OwcTextareaAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("inputChange", function OwcTextareaAccessor_inputChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcTextareaAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcTextareaAccessor_1),
                multi: true
            }
        ])] });
OwcTextareaAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcTextareaAccessor.prototype, "_handleBlurEvent", null);
let OwcTimepickerAccessor = OwcTimepickerAccessor_1 = class OwcTimepickerAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('value', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcTimepickerAccessor.ɵfac = function OwcTimepickerAccessor_Factory(t) { return new (t || OwcTimepickerAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcTimepickerAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcTimepickerAccessor, selectors: [["owc-timepicker"]], hostBindings: function OwcTimepickerAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("valueChange", function OwcTimepickerAccessor_valueChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcTimepickerAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcTimepickerAccessor_1),
                multi: true
            }
        ])] });
OwcTimepickerAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcTimepickerAccessor.prototype, "_handleBlurEvent", null);
let OwcTooltipAccessor = OwcTooltipAccessor_1 = class OwcTooltipAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('visible', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcTooltipAccessor.ɵfac = function OwcTooltipAccessor_Factory(t) { return new (t || OwcTooltipAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcTooltipAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcTooltipAccessor, selectors: [["owc-tooltip"]], hostBindings: function OwcTooltipAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("visibleChange", function OwcTooltipAccessor_visibleChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcTooltipAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcTooltipAccessor_1),
                multi: true
            }
        ])] });
OwcTooltipAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcTooltipAccessor.prototype, "_handleBlurEvent", null);
let OwcVerticalStepperAccessor = OwcVerticalStepperAccessor_1 = class OwcVerticalStepperAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('activeStep', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcVerticalStepperAccessor.ɵfac = function OwcVerticalStepperAccessor_Factory(t) { return new (t || OwcVerticalStepperAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcVerticalStepperAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcVerticalStepperAccessor, selectors: [["owc-vertical-stepper"]], hostBindings: function OwcVerticalStepperAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("stepChanged", function OwcVerticalStepperAccessor_stepChanged_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcVerticalStepperAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcVerticalStepperAccessor_1),
                multi: true
            }
        ])] });
OwcVerticalStepperAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcVerticalStepperAccessor.prototype, "_handleBlurEvent", null);
let OwcWorkflowOverlayAccessor = OwcWorkflowOverlayAccessor_1 = class OwcWorkflowOverlayAccessor {
    constructor(_renderer, el) {
        this._renderer = _renderer;
        this.el = el;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    setProperty(key, value) {
        this._renderer.setProperty(this.el.nativeElement, key, value);
    }
    getNormalizedValue(value) {
        return value == null ? undefined : value;
    }
    writeValue(value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        const normalizedValue = this.getNormalizedValue(value);
        this.lastValue = normalizedValue;
        this.setProperty('visible', normalizedValue);
    }
    handleChangeEvent(value) {
        const normalizedValue = this.getNormalizedValue(value);
        if (JSON.stringify(normalizedValue) !== JSON.stringify(this.lastValue)) {
            this.lastValue = normalizedValue;
            this.onChange(normalizedValue);
        }
    }
    _handleBlurEvent() {
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.setProperty('disabled', isDisabled);
    }
};
OwcWorkflowOverlayAccessor.ɵfac = function OwcWorkflowOverlayAccessor_Factory(t) { return new (t || OwcWorkflowOverlayAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwcWorkflowOverlayAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OwcWorkflowOverlayAccessor, selectors: [["owc-workflow-overlay"]], hostBindings: function OwcWorkflowOverlayAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("visibleChange", function OwcWorkflowOverlayAccessor_visibleChange_HostBindingHandler($event) { return ctx.handleChangeEvent($event.detail); })("focusout", function OwcWorkflowOverlayAccessor_focusout_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OwcWorkflowOverlayAccessor_1),
                multi: true
            }
        ])] });
OwcWorkflowOverlayAccessor.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    HostListener('focusout')
], OwcWorkflowOverlayAccessor.prototype, "_handleBlurEvent", null);
const DIRECTIVES = [OwcBottomNavAccessor, OwcCheckboxAccessor, OwcDatepickerAccessor, OwcDrawerAccessor, OwcExpandableAccessor, OwcHorizontalStepperAccessor, OwcInputAccessor, OwcMenuAccessor, OwcModalDialogAccessor, OwcRadioAccessor, OwcRadioGroupAccessor, OwcSlideToggleAccessor, OwcSliderAccessor, OwcSplitScreenAccessor, OwcTabsAccessor, OwcTextareaAccessor, OwcTimepickerAccessor, OwcTooltipAccessor, OwcVerticalStepperAccessor, OwcWorkflowOverlayAccessor];

applyPolyfills().then(() => {
    defineCustomElements(window);
});
const components = [...COMPONENTS];
const modules = [];
const services = [];
const directives = [...DIRECTIVES];
const guards = [];
const pipes = [];
const providers = [];
let OneWebComponentsAngularModule = class OneWebComponentsAngularModule {
};
OneWebComponentsAngularModule.ɵfac = function OneWebComponentsAngularModule_Factory(t) { return new (t || OneWebComponentsAngularModule)(); };
OneWebComponentsAngularModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OneWebComponentsAngularModule });
OneWebComponentsAngularModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [...services, ...guards, ...providers], imports: [[...modules]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InternalLifecycleActivator, [{
        type: Component,
        args: [{
                selector: 'internal-lifecycle-activator',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['loaded']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcAvatar, [{
        type: Component,
        args: [{
                selector: 'owc-avatar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBackdrop, [{
        type: Component,
        args: [{
                selector: 'owc-backdrop',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableScrollLock', 'elevation', 'height', 'minWidth', 'opacity', 'width'],
                outputs: ['backdropClick']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBadge, [{
        type: Component,
        args: [{
                selector: 'owc-badge',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['size', 'type']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBanner, [{
        type: Component,
        args: [{
                selector: 'owc-banner',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['dismissible', 'type'],
                outputs: ['dismiss']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBottomNav, [{
        type: Component,
        args: [{
                selector: 'owc-bottom-nav',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'value', 'variant'],
                outputs: ['bottomNavChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBottomNavItem, [{
        type: Component,
        args: [{
                selector: 'owc-bottom-nav-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['caption', 'disableRipple', 'icon', 'iconType', 'selected', 'value', 'variant']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBreadcrumb, [{
        type: Component,
        args: [{
                selector: 'owc-breadcrumb',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['icon']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBreadcrumbItem, [{
        type: Component,
        args: [{
                selector: 'owc-breadcrumb-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['icon', 'iconType', 'url'],
                outputs: ['handleUrl']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcButton, [{
        type: Component,
        args: [{
                selector: 'owc-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'disabled', 'flat', 'round', 'type', 'variant']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcCalendar, [{
        type: Component,
        args: [{
                selector: 'owc-calendar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['date', 'disabledDates', 'from', 'hideCurrent', 'hideHeader', 'locale', 'max', 'min', 'to', 'viewMode', 'weekStartsOn'],
                outputs: ['dateSelect', 'visibleDateChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcCard, [{
        type: Component,
        args: [{
                selector: 'owc-card',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'flat', 'round', 'scrollShadow']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcCheckbox, [{
        type: Component,
        args: [{
                selector: 'owc-checkbox',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['checked', 'disableRipple', 'disabled', 'indeterminate', 'labelPlacement', 'name'],
                outputs: ['inputChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcChip, [{
        type: Component,
        args: [{
                selector: 'owc-chip',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'disabled', 'icon', 'outlined', 'removable', 'round', 'selected'],
                outputs: ['remove']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcCookieAcceptance, [{
        type: Component,
        args: [{
                selector: 'owc-cookie-acceptance',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['acceptAllText', 'acceptSelectionText', 'barVisibility', 'cancel', 'preferences', 'settingsTitle'],
                outputs: ['acceptSelect']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcCookieAcceptanceOption, [{
        type: Component,
        args: [{
                selector: 'owc-cookie-acceptance-option',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['accepted', 'disabled', 'name']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDatepicker, [{
        type: Component,
        args: [{
                selector: 'owc-datepicker',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['autoClose', 'compact', 'disabled', 'disabledDates', 'format', 'hasClearIcon', 'invalidDateMessage', 'label', 'locale', 'maxDate', 'maxDateMessage', 'minDate', 'minDateMessage', 'name', 'placeholder', 'quick', 'required', 'requiredDateMessage', 'type', 'value', 'variant', 'weekStartsOn'],
                outputs: ['valueChange', 'panelOpen', 'panelClose']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDatepickerYearItem, [{
        type: Component,
        args: [{
                selector: 'owc-datepicker-year-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['current', 'disabled', 'selected']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDivider, [{
        type: Component,
        args: [{
                selector: 'owc-divider',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['vertical']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDoubleGlobalArea, [{
        type: Component,
        args: [{
                selector: 'owc-double-global-area',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDrawer, [{
        type: Component,
        args: [{
                selector: 'owc-drawer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['hideBackdrop', 'mini', 'mode', 'placement', 'visible'],
                outputs: ['visibleChange', 'minify']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcEditableDropdown, [{
        type: Component,
        args: [{
                selector: 'owc-editable-dropdown',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['compact', 'disabled', 'label', 'limit', 'name', 'notFoundText', 'placeholder', 'popoverStyle', 'required', 'requiredText', 'variant'],
                outputs: ['selectChange', 'panelOpen', 'panelClose', 'inputKeyDown']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcExpandable, [{
        type: Component,
        args: [{
                selector: 'owc-expandable',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'expanded', 'round', 'variant'],
                outputs: ['statusChanged']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcExpandableGroup, [{
        type: Component,
        args: [{
                selector: 'owc-expandable-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['multiple'],
                outputs: ['expandedElementsChanged']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcFilteringChip, [{
        type: Component,
        args: [{
                selector: 'owc-filtering-chip',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['applyButtonText', 'disableRipple', 'label', 'limit', 'placeholder', 'selectAllText'],
                outputs: ['selectChange', 'panelOpen', 'panelClose']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcFooter, [{
        type: Component,
        args: [{
                selector: 'owc-footer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['fixBottom']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcForm, [{
        type: Component,
        args: [{
                selector: 'owc-form',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['action', 'method', 'target'],
                outputs: ['formSubmit']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcGrid, [{
        type: Component,
        args: [{
                selector: 'owc-grid',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['columns', 'container', 'hGutter', 'item', 'l', 'm', 'padding', 's', 'vGutter', 'xl', 'xs']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcHorizontalStep, [{
        type: Component,
        args: [{
                selector: 'owc-horizontal-step',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['active', 'completed', 'condensed', 'disabled', 'linear', 'number', 'optionalText']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcHorizontalStepper, [{
        type: Component,
        args: [{
                selector: 'owc-horizontal-stepper',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['activeStep', 'condensed', 'linear'],
                outputs: ['stepChanged']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcHyperlink, [{
        type: Component,
        args: [{
                selector: 'owc-hyperlink',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['href', 'prose', 'rel', 'target']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcIcon, [{
        type: Component,
        args: [{
                selector: 'owc-icon',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['name', 'type', 'variant']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcIconButton, [{
        type: Component,
        args: [{
                selector: 'owc-icon-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'disabled', 'flat', 'icon', 'type']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcInput, [{
        type: Component,
        args: [{
                selector: 'owc-input',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['autoFocus', 'compact', 'disabled', 'error', 'focusedView', 'label', 'max', 'maxLength', 'min', 'minLength', 'name', 'pattern', 'placeholder', 'required', 'round', 'selectionEnd', 'selectionStart', 'type', 'value', 'variant'],
                outputs: ['inputChange', 'inputKeyDown']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcList, [{
        type: Component,
        args: [{
                selector: 'owc-list',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['handleOnFocus', 'multiple', 'size'],
                outputs: ['selectChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcListItem, [{
        type: Component,
        args: [{
                selector: 'owc-list-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'disabled', 'drawer', 'icon', 'iconType', 'indent', 'noBorder', 'secondaryText', 'selected', 'size', 'tooltipPlacement']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcMenu, [{
        type: Component,
        args: [{
                selector: 'owc-menu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['alignment', 'anchor', 'autoUnportal', 'disablePortal', 'limit', 'offset', 'scrollPadding', 'strategy', 'verticalPlacement', 'visible'],
                outputs: ['visibleChange', 'clickOutside']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcModalDialog, [{
        type: Component,
        args: [{
                selector: 'owc-modal-dialog',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['denseContent', 'disableBackdropClick', 'disableEscapeKeydown', 'disableScrollLock', 'hideBackdrop', 'size', 'visible', 'width'],
                outputs: ['visibleChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcNotificationDrawer, [{
        type: Component,
        args: [{
                selector: 'owc-notification-drawer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['limit']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcPagination, [{
        type: Component,
        args: [{
                selector: 'owc-pagination',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['options', 'page', 'rowsPerPage', 'showPerPage', 'total'],
                outputs: ['pageChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcPopover, [{
        type: Component,
        args: [{
                selector: 'owc-popover',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['anchor', 'anchorPosition', 'autoUnportal', 'disablePortal', 'offset', 'strategy', 'visible'],
                outputs: ['visibleChange', 'clickOutside']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcProgressBar, [{
        type: Component,
        args: [{
                selector: 'owc-progress-bar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['caption', 'mode', 'value']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcProgressSpinner, [{
        type: Component,
        args: [{
                selector: 'owc-progress-spinner',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['diameter', 'mode', 'value']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcRadio, [{
        type: Component,
        args: [{
                selector: 'owc-radio',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['checked', 'disableRipple', 'disabled', 'labelPlacement', 'name', 'value'],
                outputs: ['inputChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcRadioGroup, [{
        type: Component,
        args: [{
                selector: 'owc-radio-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'name', 'value'],
                outputs: ['inputChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSelectDropdown, [{
        type: Component,
        args: [{
                selector: 'owc-select-dropdown',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'label', 'limit', 'multiple', 'name', 'outlined', 'placeholder', 'popoverStyle', 'required', 'requiredText', 'selectAllText', 'size'],
                outputs: ['selectChange', 'panelOpen', 'panelClose']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSkeletonLoader, [{
        type: Component,
        args: [{
                selector: 'owc-skeleton-loader',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['animation', 'variant']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSlideToggle, [{
        type: Component,
        args: [{
                selector: 'owc-slide-toggle',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['checked', 'disableRipple', 'disabled', 'labelPlacement'],
                outputs: ['inputChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSlider, [{
        type: Component,
        args: [{
                selector: 'owc-slider',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'inverted', 'max', 'min', 'shiftValue', 'showTicks', 'showValueLabel', 'step', 'tickIntervals', 'value', 'vertical'],
                outputs: ['valueChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSliderMarker, [{
        type: Component,
        args: [{
                selector: 'owc-slider-marker',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'selected', 'value']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSnackbar, [{
        type: Component,
        args: [{
                selector: 'owc-snackbar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['action', 'content', 'duration', 'horizontalPlacement', 'htmlContent', 'type', 'verticalPlacement'],
                outputs: ['actionBtn', 'open', 'close']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSplitScreen, [{
        type: Component,
        args: [{
                selector: 'owc-split-screen',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'size', 'vertical'],
                outputs: ['sizeChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTab, [{
        type: Component,
        args: [{
                selector: 'owc-tab',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'selected', 'value']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTable, [{
        type: Component,
        args: [{
                selector: 'owc-table',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableScroll', 'dragEnabled', 'height', 'scrollHideTimeout', 'spacing', 'stickyColumn']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableBody, [{
        type: Component,
        args: [{
                selector: 'owc-table-body',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['dragEnabled', 'loading']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableCell, [{
        type: Component,
        args: [{
                selector: 'owc-table-cell',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['align', 'editable', 'editing', 'spacing', 'sticky', 'valign'],
                outputs: ['contentChange', 'editModeChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableGroup, [{
        type: Component,
        args: [{
                selector: 'owc-table-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['expandable', 'expanded', 'hasCheckbox', 'header', 'indentation', 'leadingExpandableCol', 'spacing', 'stickyColumn'],
                outputs: ['expandChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableHeader, [{
        type: Component,
        args: [{
                selector: 'owc-table-header',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['checboxState', 'elevated', 'hasCheckbox', 'indentation', 'leadingExpandableCol', 'shrink', 'spacing', 'sticky', 'stickyColumn', 'trailingExpandableCol'],
                outputs: ['columnWidthsChange', 'selectAllStateChange', 'columnResize']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableHeaderCell, [{
        type: Component,
        args: [{
                selector: 'owc-table-header-cell',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['align', 'noClip', 'resizable', 'sortOrder', 'sortable', 'spacing', 'sticky', 'valign', 'width'],
                outputs: ['sortChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableRow, [{
        type: Component,
        args: [{
                selector: 'owc-table-row',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['columnWidths', 'disabled', 'expandable', 'expanded', 'hasCheckbox', 'indentation', 'locked', 'selectable', 'selected', 'spacing', 'stickyColumn'],
                outputs: ['selectChange', 'expandChange', 'indexChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTableSpacingDialog, [{
        type: Component,
        args: [{
                selector: 'owc-table-spacing-dialog',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['applyButtonText', 'closeButtonText', 'compactHeading', 'contentTitle', 'defaultHeading', 'denseFootnote', 'denseHeading', 'header', 'spacing', 'visible'],
                outputs: ['dialogOpen', 'dialogClose', 'apply']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTabs, [{
        type: Component,
        args: [{
                selector: 'owc-tabs',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'value'],
                outputs: ['tabChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTextarea, [{
        type: Component,
        args: [{
                selector: 'owc-textarea',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['assistiveText', 'cols', 'disabled', 'errorText', 'label', 'maxLength', 'minLength', 'placeholder', 'required', 'reset', 'resizable', 'rows', 'validationMode', 'validator', 'value', 'variant'],
                outputs: ['inputChange', 'inputKeyDown', 'inputReset']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTimepicker, [{
        type: Component,
        args: [{
                selector: 'owc-timepicker',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['compact', 'disabled', 'format', 'hasClearIcon', 'invalidTimeMessage', 'label', 'locale', 'maxTime', 'maxTimeMessage', 'minTime', 'minTimeMessage', 'name', 'native', 'placeholder', 'popoverStyle', 'required', 'requiredTimeMessage', 'selectOutOfStep', 'step', 'unavailable', 'value', 'variant'],
                outputs: ['panelOpen', 'panelClose', 'valueChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcToggleButton, [{
        type: Component,
        args: [{
                selector: 'owc-toggle-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disableRipple', 'disabled', 'selected']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcToggleButtonGroup, [{
        type: Component,
        args: [{
                selector: 'owc-toggle-button-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['disabled', 'flat', 'round'],
                outputs: ['selectChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTooltip, [{
        type: Component,
        args: [{
                selector: 'owc-tooltip',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['anchor', 'autoUnportal', 'disablePortal', 'disableTriggers', 'enterDelay', 'leaveDelay', 'offset', 'placement', 'strategy', 'visible'],
                outputs: ['visibleChange', 'clickOutside']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTypography, [{
        type: Component,
        args: [{
                selector: 'owc-typography',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['element', 'variant']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcVerticalStep, [{
        type: Component,
        args: [{
                selector: 'owc-vertical-step',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['active', 'completed', 'disabled', 'linear', 'step']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcVerticalStepper, [{
        type: Component,
        args: [{
                selector: 'owc-vertical-stepper',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['activeStep', 'linear', 'numbered'],
                outputs: ['stepChanged']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcWorkflowOverlay, [{
        type: Component,
        args: [{
                selector: 'owc-workflow-overlay',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                inputs: ['height', 'visible', 'width'],
                outputs: ['visibleChange']
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcBottomNavAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-bottom-nav',
                host: {
                    '(bottomNavChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcBottomNavAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcCheckboxAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-checkbox',
                host: {
                    '(inputChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcCheckboxAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDatepickerAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-datepicker',
                host: {
                    '(valueChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcDatepickerAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcDrawerAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-drawer',
                host: {
                    '(visibleChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcDrawerAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcExpandableAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-expandable',
                host: {
                    '(statusChanged)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcExpandableAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcHorizontalStepperAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-horizontal-stepper',
                host: {
                    '(stepChanged)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcHorizontalStepperAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcInputAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-input',
                host: {
                    '(inputChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcInputAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcMenuAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-menu',
                host: {
                    '(visibleChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcMenuAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcModalDialogAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-modal-dialog',
                host: {
                    '(visibleChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcModalDialogAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcRadioAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-radio',
                host: {
                    '(inputChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcRadioAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcRadioGroupAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-radio-group',
                host: {
                    '(inputChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcRadioGroupAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSlideToggleAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-slide-toggle',
                host: {
                    '(inputChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcSlideToggleAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSliderAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-slider',
                host: {
                    '(valueChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcSliderAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcSplitScreenAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-split-screen',
                host: {
                    '(sizeChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcSplitScreenAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTabsAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-tabs',
                host: {
                    '(tabChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcTabsAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTextareaAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-textarea',
                host: {
                    '(inputChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcTextareaAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTimepickerAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-timepicker',
                host: {
                    '(valueChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcTimepickerAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcTooltipAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-tooltip',
                host: {
                    '(visibleChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcTooltipAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcVerticalStepperAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-vertical-stepper',
                host: {
                    '(stepChanged)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcVerticalStepperAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwcWorkflowOverlayAccessor, [{
        type: Directive,
        args: [{
                selector: 'owc-workflow-overlay',
                host: {
                    '(visibleChange)': 'handleChangeEvent($event.detail)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => OwcWorkflowOverlayAccessor_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OneWebComponentsAngularModule, [{
        type: NgModule,
        args: [{
                imports: [...modules],
                exports: [...modules, ...components, ...directives, ...pipes],
                declarations: [...components, ...directives, ...pipes],
                entryComponents: [],
                providers: [...services, ...guards, ...providers]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OneWebComponentsAngularModule, { declarations: [InternalLifecycleActivator, OwcAvatar, OwcBackdrop, OwcBadge, OwcBanner, OwcBottomNav, OwcBottomNavItem, OwcBreadcrumb, OwcBreadcrumbItem, OwcButton, OwcCalendar, OwcCard, OwcCheckbox, OwcChip, OwcCookieAcceptance, OwcCookieAcceptanceOption, OwcDatepicker, OwcDatepickerYearItem, OwcDivider, OwcDoubleGlobalArea, OwcDrawer, OwcEditableDropdown, OwcExpandable, OwcExpandableGroup, OwcFilteringChip, OwcFooter, OwcForm, OwcGrid, OwcHorizontalStep, OwcHorizontalStepper, OwcHyperlink, OwcIcon, OwcIconButton, OwcInput, OwcList, OwcListItem, OwcMenu, OwcModalDialog, OwcNotificationDrawer, OwcPagination, OwcPopover, OwcProgressBar, OwcProgressSpinner, OwcRadio, OwcRadioGroup, OwcSelectDropdown, OwcSkeletonLoader, OwcSlideToggle, OwcSlider, OwcSliderMarker, OwcSnackbar, OwcSplitScreen, OwcTab, OwcTable, OwcTableBody, OwcTableCell, OwcTableGroup, OwcTableHeader, OwcTableHeaderCell, OwcTableRow, OwcTableSpacingDialog, OwcTabs, OwcTextarea, OwcTimepicker, OwcToggleButton, OwcToggleButtonGroup, OwcTooltip, OwcTypography, OwcVerticalStep, OwcVerticalStepper, OwcWorkflowOverlay, OwcBottomNavAccessor, OwcCheckboxAccessor, OwcDatepickerAccessor, OwcDrawerAccessor, OwcExpandableAccessor, OwcHorizontalStepperAccessor, OwcInputAccessor, OwcMenuAccessor, OwcModalDialogAccessor, OwcRadioAccessor, OwcRadioGroupAccessor, OwcSlideToggleAccessor, OwcSliderAccessor, OwcSplitScreenAccessor, OwcTabsAccessor, OwcTextareaAccessor, OwcTimepickerAccessor, OwcTooltipAccessor, OwcVerticalStepperAccessor, OwcWorkflowOverlayAccessor], exports: [InternalLifecycleActivator, OwcAvatar, OwcBackdrop, OwcBadge, OwcBanner, OwcBottomNav, OwcBottomNavItem, OwcBreadcrumb, OwcBreadcrumbItem, OwcButton, OwcCalendar, OwcCard, OwcCheckbox, OwcChip, OwcCookieAcceptance, OwcCookieAcceptanceOption, OwcDatepicker, OwcDatepickerYearItem, OwcDivider, OwcDoubleGlobalArea, OwcDrawer, OwcEditableDropdown, OwcExpandable, OwcExpandableGroup, OwcFilteringChip, OwcFooter, OwcForm, OwcGrid, OwcHorizontalStep, OwcHorizontalStepper, OwcHyperlink, OwcIcon, OwcIconButton, OwcInput, OwcList, OwcListItem, OwcMenu, OwcModalDialog, OwcNotificationDrawer, OwcPagination, OwcPopover, OwcProgressBar, OwcProgressSpinner, OwcRadio, OwcRadioGroup, OwcSelectDropdown, OwcSkeletonLoader, OwcSlideToggle, OwcSlider, OwcSliderMarker, OwcSnackbar, OwcSplitScreen, OwcTab, OwcTable, OwcTableBody, OwcTableCell, OwcTableGroup, OwcTableHeader, OwcTableHeaderCell, OwcTableRow, OwcTableSpacingDialog, OwcTabs, OwcTextarea, OwcTimepicker, OwcToggleButton, OwcToggleButtonGroup, OwcTooltip, OwcTypography, OwcVerticalStep, OwcVerticalStepper, OwcWorkflowOverlay, OwcBottomNavAccessor, OwcCheckboxAccessor, OwcDatepickerAccessor, OwcDrawerAccessor, OwcExpandableAccessor, OwcHorizontalStepperAccessor, OwcInputAccessor, OwcMenuAccessor, OwcModalDialogAccessor, OwcRadioAccessor, OwcRadioGroupAccessor, OwcSlideToggleAccessor, OwcSliderAccessor, OwcSplitScreenAccessor, OwcTabsAccessor, OwcTextareaAccessor, OwcTimepickerAccessor, OwcTooltipAccessor, OwcVerticalStepperAccessor, OwcWorkflowOverlayAccessor] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { InternalLifecycleActivator, OneWebComponentsAngularModule, OwcAvatar, OwcBackdrop, OwcBadge, OwcBanner, OwcBottomNav, OwcBottomNavItem, OwcBreadcrumb, OwcBreadcrumbItem, OwcButton, OwcCalendar, OwcCard, OwcCheckbox, OwcChip, OwcCookieAcceptance, OwcCookieAcceptanceOption, OwcDatepicker, OwcDatepickerYearItem, OwcDivider, OwcDoubleGlobalArea, OwcDrawer, OwcEditableDropdown, OwcExpandable, OwcExpandableGroup, OwcFilteringChip, OwcFooter, OwcForm, OwcGrid, OwcHorizontalStep, OwcHorizontalStepper, OwcHyperlink, OwcIcon, OwcIconButton, OwcInput, OwcList, OwcListItem, OwcMenu, OwcModalDialog, OwcNotificationDrawer, OwcPagination, OwcPopover, OwcProgressBar, OwcProgressSpinner, OwcRadio, OwcRadioGroup, OwcSelectDropdown, OwcSkeletonLoader, OwcSlideToggle, OwcSlider, OwcSliderMarker, OwcSnackbar, OwcSplitScreen, OwcTab, OwcTable, OwcTableBody, OwcTableCell, OwcTableGroup, OwcTableHeader, OwcTableHeaderCell, OwcTableRow, OwcTableSpacingDialog, OwcTabs, OwcTextarea, OwcTimepicker, OwcToggleButton, OwcToggleButtonGroup, OwcTooltip, OwcTypography, OwcVerticalStep, OwcVerticalStepper, OwcWorkflowOverlay, ProxyCmp as ɵa, COMPONENTS as ɵb, OwcBottomNavAccessor as ɵc, OwcCheckboxAccessor as ɵd, OwcDatepickerAccessor as ɵe, OwcDrawerAccessor as ɵf, OwcExpandableAccessor as ɵg, OwcHorizontalStepperAccessor as ɵh, OwcInputAccessor as ɵi, OwcMenuAccessor as ɵj, OwcModalDialogAccessor as ɵk, OwcRadioAccessor as ɵl, OwcRadioGroupAccessor as ɵm, OwcSlideToggleAccessor as ɵn, OwcSliderAccessor as ɵo, OwcSplitScreenAccessor as ɵp, OwcTabsAccessor as ɵq, OwcTextareaAccessor as ɵr, OwcTimepickerAccessor as ɵs, OwcTooltipAccessor as ɵt, OwcVerticalStepperAccessor as ɵu, OwcWorkflowOverlayAccessor as ɵv, DIRECTIVES as ɵw };

